<template>
  <template v-if="editionMode">
    <div
      class="fm-form-input"
      :class="{
        'mt-2': !!label
      }"
    >
      <BaseLabelTop
        :target="name"
        :label="label"
        :disabled="disabled"
        :required="required"
      />
      <div class="relative min-w-0 flex-1 rounded-md">
        <input
          :id="name"
          v-model="model"
          type="number"
          :name="name"
          :disabled="disabled"
          :class="[
            disabled
              ? 'pointer-events-none bg-gray-100 text-gray-500'
              : 'bg-white',
            $attrs.class
          ]"
          class="rounded-md"
        />
        <div
          class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
        >
          <span id="price-currency" class="text-gray-500 sm:text-sm">
            {{ measure }}
          </span>
        </div>
      </div>
    </div>
    <ErrorContainer :error-key="name" :errors="errors" />
  </template>
  <template v-else>
    <div class="fm-form-input" :class="[label ? 'mt-2' : '']">
      <label>
        {{ label }}
      </label>
      <div class="relative min-w-0 flex-1 rounded-md">
        <input
          v-model="model"
          type="text"
          readonly
          :class="[
            editionMode ? 'bg-gray-100' : '',
            disabled ? 'pointer-events-none bg-gray-100 text-gray-500' : '',
            $attrs.class
          ]"
          :disabled="disabled"
          class="rounded-md"
        />
        <div
          class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
        >
          <span id="price-currency" class="text-gray-500 sm:text-sm">
            {{ measure }}
          </span>
        </div>
      </div>
    </div>
  </template>
</template>
<script>
import BaseLabelTop from '@c/addf-package/components/BaseLabel/BaseLabelTop.vue'
import ErrorContainer from '@c/addf-package/components/BaseShowEditInput/ErrorContainer.vue'

export default {
  name: 'BaseShowEditMeasureInput',
  components: { ErrorContainer, BaseLabelTop },
  props: {
    label: {
      type: String,
      required: false,
      default: ''
    },
    editionMode: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    modelValue: {
      type: [String, Number],
      required: true
    },
    name: {
      type: String,
      default: ''
    },
    measure: {
      type: String,
      required: true
    },
    errors: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    model: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  }
}
</script>
